import alpha from './core/alpha';
import background from './core/background';
import black from './core/black';
import grayScale from './core/grayScale';
import blue from './blue';
import green from './green';
import maroon from './maroon';
import orange from './orange';
import red from './red';
import text from './core/text';
import white from './core/white';

const defaultColors = {
    alpha,
    background,
    black,
    blue,
    grayScale,
    green,
    maroon,
    orange,
    red,
    text,
    white,
};

export default defaultColors;
